import { IServiceResult } from "../../infrastructure/Interfaces/IServiceResult";
import { SVCPacPat } from "../../infrastructure/services/api/SVCPacPat";
import IViewCombo from '../../presentation/view-interfaces/IViewCombo'

export const IniciarMandatoPat = (selIniciarMandato: any, rut: number, codigoNegocio: number, codigoPrograma: string, codigoPlanificacionAcademica: number, agnoProceso: number) => {
    let list: any = [];
    SVCPacPat.IniciarMandatoPat(rut, codigoNegocio, codigoPrograma, codigoPlanificacionAcademica, agnoProceso).then((res: IServiceResult<any>) => {
        if (res.result !== undefined) {
            let data: any = res.result;

            selIniciarMandato(false, '', data);
        } else {
            selIniciarMandato(true, res.errorDetails, list);
        }
    });

};

export const ValidarMandatoPat = (selValidarMandato: any, token: string, rutAlumno: number, codPrograma: string) => {
    let list: any = [];
    SVCPacPat.ValidarMandatoPat(token, rutAlumno, codPrograma).then((res: IServiceResult<any>) => {
        if (res.result !== undefined) {
            let data: any = res.result;

            selValidarMandato(false, '', data);
        } else {
            selValidarMandato(true, res.errorDetails, list);
        }
    });

};
export const ObtenerBancosGPA = (selListBancos: any) => {
    let list: Array<IViewCombo> = [];
    SVCPacPat.ObtenerBancosGPA().then((res: IServiceResult<any>) => {
        if (res.result !== undefined) {
            let data: any = res.result;
            data.map((e: any) => {
                list.push({ ID: e.idBanco, descripcion: e.nombre });
            });
            selListBancos(false, '', list);
        } else {
            selListBancos(true, res.errorDetails, list);
        }
    });

};
export const IniciarMandatoPac = (selIniciarMandato: any, data: any) => {
    let list: any = [];
    SVCPacPat.IniciarMandatoPac(data).then((res: IServiceResult<any>) => {
        if (res.result !== undefined) {
            let data: any = res.result;

            selIniciarMandato(false, '', data);
        } else {
            selIniciarMandato(true, res.errorDetails, list);
        }
    });

};
export const InsertarMandatoPat = (selIniciarMandato: any, data: any) => {
    let list: any = [];
    SVCPacPat.InsertarMandatoPat(data).then((res: IServiceResult<any>) => {
        if (res.result !== undefined) {
            let data: any = res.result;

            selIniciarMandato(false, '', data);
        } else {
            selIniciarMandato(true, res.errorDetails, list);
        }
    });

};
export const TieneMandatoPac = (selTieneMandato: any, codCarrera: string, rutAlumno: number, tipoMandato: number, tipoOrigen: number) => {
    let list: any = [];
    SVCPacPat.TieneMandatoPac(codCarrera, rutAlumno, tipoMandato, tipoOrigen).then((res: IServiceResult<any>) => {
        if (res.result !== undefined) {
            let data: any = res.result;

            selTieneMandato(false, '', data);
        } else {
            selTieneMandato(true, res.errorDetails, list);
        }
    });

};
export const TieneMandatoPat = (selTieneMandato: any, codCarrera: string, rutAlumno: number, tipoMandato: number, tipoOrigen: number) => {
    let list: any = [];
    SVCPacPat.TieneMandatoPat(codCarrera, rutAlumno, tipoMandato, tipoOrigen).then((res: IServiceResult<any>) => {
        if (res.result !== undefined) {
            let data: any = res.result;

            selTieneMandato(false, '', data);
        } else {
            selTieneMandato(true, res.errorDetails, list);
        }
    });

};
export const ObtenerDatosAlumno = (selListAlumno: any, rut: number, codCarrera: string, esFormularioPAC: boolean) => {
    let list: any = [];
    SVCPacPat.ObtenerDatosAlumno(rut, codCarrera, esFormularioPAC).then((res: IServiceResult<any>) => {
        if (res.result !== undefined) {
            let data: any = res.result;

            selListAlumno(false, '', data);
        } else {
            selListAlumno(true, res.errorDetails, list);
        }
    });

};
export const ObtieneComprobante = (selListComprobante: any, codCarrera: string, rutAlumno: number, tipoMandato: number, tipoOrigen: number) => {
    let list: any = [];
    SVCPacPat.ObtieneComprobante(codCarrera, rutAlumno, tipoMandato, tipoOrigen).then((res: IServiceResult<any>) => {
        if (res.result !== undefined) {
            let data: any = res.result;

            selListComprobante(false, '', data);
        } else {
            selListComprobante(true, res.errorDetails, list);
        }
    });

};